import ReactDOM from 'react-dom';

import App from 'components/App';
import 'utils/icons';
import 'index.css';

ReactDOM.render(<App />, document.getElementById('root'));
// 1
